<template>
  <div class="map-elem-info car">
    <div class="col-icon">
      <img class="resource-icon" :src="iconPath">
    </div>
    <div class="col-info">
      <div class="ft-bold">
        <span class="ib lbl">車両番号:</span>
        <span class="ib val">{{car.device.carName}}</span>
      </div>
      <div>
        <span class="ib lbl">所属:</span>
        <span class="ib val mr4">{{car.device.groupInfo.g2name}}</span>
        <span class="ib val">{{car.device.groupInfo.g3name}}</span>
      </div>
      <div>
        <span class="ib lbl">状態:</span>
        <span class="ib val">{{car.statusDisp}}</span>
      </div>
      <div>
        <span class="ib lbl">車種:</span>
        <span class="ib val">{{car.device.carKindDisp}}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { MapElemInfo } from 'src/models';
import type { GICar } from 'src/models/geoItem';
import { carKindsWithSpecialImg } from 'src/consts/car_kinds_with_special_img';

interface Props {
  elem: MapElemInfo<GICar>;
}

const props = withDefaults(defineProps<Props>(), {});

const car = computed<GICar>(() => props.elem.data);

const iconPath = computed<string>(() => {
  const carIconPrefix = '/static/img/car_';
  const statusPrefix = car.value.isMoving ? 'moving_' : 'stopped_';
  const imgCarKind = carKindsWithSpecialImg[car.value.device.carKind] || 'default';
  return `${carIconPrefix}${statusPrefix}${imgCarKind}.png`;
});
</script>

<style lang="scss" scoped>
.map-elem-info {
  .col-icon {
    margin-right: 4px;
    .resource-icon {
      width: 48px;
    }
  }
  .col-info {
    .lbl {
      margin-right: 4px;
    }
  }
}
</style>
